import { useState } from "react";
import { useFaturas } from "../../hooks/fatura/useFaturas"
import { Loading } from "../../components/Loading";
import { Box, Portal, Table, TableContainer, Tbody, Th, Thead, Tr, useDisclosure } from "@chakra-ui/react";
import { Pagination } from "../../components/Pagination";
import { Item } from "./Item";
import { ModalPix } from "./ModalPix";
import { Fatura, Pix } from "../../utils/interfaces";

export function Lista(){
  const [page, setPage] = useState(1);
  const {data, isLoading} = useFaturas({ page })
  const {isOpen, onClose, onOpen} = useDisclosure()
  const [fatura, setFatura] = useState<Fatura | null>(null)
  const [pixMode, setPixMode] = useState<'fatura' | 'parcial' | 'total_caixa'>('fatura')
  const [pixSelecionado, setPixSelecionado] = useState<Pix | null>(null)

  if (isLoading) return <Loading />;

  const handlePix = (fatura: Fatura, mode: 'fatura' | 'parcial' | 'total_caixa' = 'fatura', pix?: Pix) => {
    setFatura(fatura)
    setPixMode(mode)
    setPixSelecionado(pix ?? null)
    onOpen();
  }

  return (
    <>
    <Portal>
      {fatura && 
        <ModalPix isOpen={isOpen} fatura={fatura} mode={pixMode} pixSelecionado={pixSelecionado} onClose={onClose} />
      }
    </Portal>
    <Box
      gap={8}
      fontSize={"sm"}
      p={"5"}
      border={"1px solid #ccc"}
      display={"flex"}
      flexDir={"column"}
    >
        <Box
          mt={"-8"}
          fontWeight={"bold"}
          bg={"white"}
          as={"span"}
          w={"150px"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          Faturamento
        </Box>
    <TableContainer>
      <Table variant={"striped"}>
        <Thead>
          <Tr color={'white'}>
            <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>ID</Th>
            <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>CÓDIGO</Th>
            <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>STATUS</Th>
            <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>DATA VENCIMENTO</Th>
            <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>EMISSÃO</Th>
            <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>VALOR</Th>
            <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>FORMA PAGAMENTO</Th>
            <Th bg={'#525252'} color={'white'} p={0} textAlign={'center'}>AÇÕES</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.pedidos.map(item => <Item onPix={handlePix} key={item.id} fatura={item} />)}
        </Tbody>
      </Table>
    </TableContainer>
    </Box>
    <Pagination
          onPageChange={setPage}
          currentPage={data?.meta.current_page}
          lastPage={data?.meta.last_page}
          numberOfItens={data?.pedidos.length}
          numberToPage={data?.meta.to}
          registerPerPage={data?.meta.per_page}
          totalCountofRegisters={data?.meta.total}
        />
  </>
  )
}
